import React, { FC } from "react";
import { YhFormItemsBox } from "@/components/YhFormBox";
import { IYhFormItemsBox, FormItemTypeEnum } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { useShipmentDetailModel } from "../shipmentDetailModel";

export const FormBoxItem: FC<RouterParamType> = ({ id, mode }) => {
    const {
        editFormVal
    } = useShipmentDetailModel();
    const FormBoxItem: IYhFormItemsBox = {
        title: "装箱信息",
        style: { padding: "10px 0 0 0", marginBottom: "10px", width: "100%" },
        contentClass: "pr-2",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "集装箱数",
                fieldName: "containerNum",
                disable: editFormVal.status == 'shipment.bl'
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "件数",
                fieldName: "number",
                disable: editFormVal.status == 'shipment.bl'
            },{
                type: FormItemTypeEnum.Input,
                fieldLabel: "体积",
                fieldName: "volume",
                disable: editFormVal.status == 'shipment.bl'
            }
        ]
    };

    return (
        <YhFormItemsBox {...FormBoxItem} />
    )
}